import styles from "./BpsTablePagination.module.scss";
import { ChervonLeft, ChevronRight } from "../../../../assets/icons";

interface BpsTablePaginationProps {
	page: number;
	pageSize: number;
	totalItems: number;
	onPageChange: (page: number) => void;
}

const WINDOW_SIZE = 5;

/** Page numbers to show — a sliding window of at most WINDOW_SIZE around `page`. */
function pageWindow(page: number, totalPages: number): number[] {
	let start = Math.max(1, page - Math.floor(WINDOW_SIZE / 2));
	const end = Math.min(totalPages, start + WINDOW_SIZE - 1);
	start = Math.max(1, end - WINDOW_SIZE + 1);

	return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}

export function BpsTablePagination({ page, pageSize, totalItems, onPageChange }: Readonly<BpsTablePaginationProps>) {
	const totalPages = Math.ceil(totalItems / pageSize);

	if (totalItems === 0) return null;

	const isFirst = page <= 1;
	const isLast = page >= totalPages;

	return (
		<div className={styles.container}>
			<span className={styles.pageInfo}>
				Page {page} of {totalPages}
			</span>

			<div className={styles.controls}>
				<button className={styles.button} title="First page" disabled={isFirst} onClick={() => onPageChange(1)}>
					<span className={styles.doubleChevron}>
						<ChervonLeft />
						<ChervonLeft />
					</span>
				</button>
				<button className={styles.button} title="Previous page" disabled={isFirst} onClick={() => onPageChange(page - 1)}>
					<ChervonLeft />
				</button>

				{pageWindow(page, totalPages).map(pageNumber => (
					<button
						key={pageNumber}
						className={`${styles.button} ${pageNumber === page ? styles.active : ""}`}
						onClick={() => onPageChange(pageNumber)}
					>
						{pageNumber}
					</button>
				))}

				<button className={styles.button} title="Next page" disabled={isLast} onClick={() => onPageChange(page + 1)}>
					<ChevronRight />
				</button>
				<button className={styles.button} title="Last page" disabled={isLast} onClick={() => onPageChange(totalPages)}>
					<span className={styles.doubleChevron}>
						<ChevronRight />
						<ChevronRight />
					</span>
				</button>
			</div>
		</div>
	);
}
